<template>
  <section class="invoice-attachments" aria-label="发票附件">
    <div class="common-title">发票文件</div>
    <div v-if="loading" class="file-note">正在加载发票文件…</div>
    <el-alert v-else-if="error" :title="error" type="error" :closable="false" show-icon><el-button type="text" @click="load">重试</el-button></el-alert>
    <template v-else>
      <p v-if="!files.length" class="file-note">暂无可查看的发票文件，请联系财务确认。</p>
      <p v-if="manualCompleted" class="file-note">人工上传完成{{ completedAt ? ' · ' + completedAt : '' }}，发票文件不可更换。</p>
      <div v-for="file in files" :key="file.attachmentId" class="invoice-file-row">
        <span class="file-icon">{{ file.contentType === 'application/pdf' ? 'PDF' : '图片' }}</span>
        <div class="file-name"><div>{{ file.fileName || '发票文件' }}</div><small>{{ size(file.fileSize) }}</small></div>
        <el-button size="mini" :disabled="!!openingId" @click="open(file, 1)">预览</el-button><el-button type="primary" size="mini" :disabled="!!openingId" @click="open(file, 2)">下载</el-button>
      </div>
    </template>
  </section>
</template>

<script>
import api from '@/api/finance/invoiceApplicationAudit'
import { invoiceIdOf, replyData, displaySize } from './manualInvoice'

export default {
  props: { invoiceId: { type: [String, Number], required: true } },
  data() { return { loading: false, error: '', files: [], openingId: '', completedAt: '', manualCompleted: false, invoiceSource: '', epoch: 0 } },
  watch: { invoiceId: { immediate: true, handler() { this.load() } } },
  beforeDestroy() { this.epoch++ },
  methods: {
    size: displaySize,
    async load() {
      const epoch = ++this.epoch
      this.loading = true; this.error = ''; this.files = []; this.openingId = ''; this.manualCompleted = false; this.completedAt = ''; this.invoiceSource = ''
      try {
        const data = replyData(await api.attachments(invoiceIdOf(this.invoiceId)))
        if (epoch !== this.epoch) return
        if (Number(data.state) !== 2) throw new Error('发票尚未开具完成')
        if (!Array.isArray(data.attachments)) throw new Error('发票文件清单不完整，请重试')
        this.files = data.attachments; this.manualCompleted = data.manualCompleted === true; this.completedAt = data.completedAt || ''
        this.invoiceSource = data.invoiceSource || ''
      } catch (e) { if (epoch === this.epoch) this.error = e.message || '发票文件加载失败，请重试' }
      finally { if (epoch === this.epoch) this.loading = false }
    },
    async open(file, mode) {
      if (this.openingId) return
      const epoch = this.epoch
      const win = window.open('', '_blank')
      if (!win) { this.$message.warning('请允许本站打开文件窗口后重试'); return }
      win.opener = null
      this.openingId = file.attachmentId
      let opened = false
      try {
        const data = replyData(await api.attachmentFile({ invoiceId: invoiceIdOf(this.invoiceId), attachmentId: file.attachmentId, mode }))
        if (epoch !== this.epoch) return
        const url = new URL(data.fileUrl)
        const legacyHttp = this.invoiceSource === 'LEGACY' && file.attachmentId === 'legacy-pdf' && url.protocol === 'http:'
        if ((url.protocol !== 'https:' && !legacyHttp) || url.username || url.password) throw new Error('发票文件地址不可用')
        win.location.href = url.href; opened = true
      } catch (e) { if (epoch === this.epoch) this.$message.error(e.message || '文件打开失败，请重试') }
      finally { if (!opened) win.close(); if (epoch === this.epoch) this.openingId = '' }
    }
  }
}
</script>

<style scoped>
.file-note { color: #606266; font-size: 13px; line-height: 24px; }
.invoice-file-row { display: flex; align-items: center; gap: 10px; padding: 16px 0; border-bottom: 1px solid #ebeef5; }
.file-icon { flex-shrink: 0; border-radius: 6px; padding: 14px 8px; background: #fff1f0; color: #d33; }
.file-name { flex: 1; min-width: 0; overflow-wrap: anywhere; line-height: 22px; }
.file-name small { color: #909399; }
</style>
